import React from 'react';
import { Box } from '@material-ui/core';
import style from './renderDaysHeaderStyle';

function RenderDaysHeader({ showWalCal }) {
	const classes = style();
	let daysHeader = ['SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI'];

	if (!showWalCal) {
		daysHeader = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
	}
	return daysHeader?.map((header, index) => {
		return (
			<Box className={classes.dayHeader} key={index}>
				{header}
			</Box>
		);
	});
}

export default RenderDaysHeader;
